export enum Game {
  GANDALF = 'gandalf',
  VISION0 = 'vision0',
}
